import { useEffect } from "react";

const CHECK_INTERVAL_MS = 300;

/**
 * AdSense 스크립트가 로드되면 해당 <ins> 슬롯에 광고를 한 번만 요청합니다.
 * 이미 채워진 슬롯(data-adsbygoogle-status)은 다시 push하지 않아
 * 개발 모드(StrictMode)의 이중 실행이나 재마운트에서도 오류가 나지 않습니다.
 */
export const useAdsense = (insRef) => {
  useEffect(() => {
    const pushAd = () => {
      const ins = insRef.current;
      if (!ins || ins.getAttribute("data-adsbygoogle-status")) return;
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error(e);
      }
    };

    // AdSense 스크립트가 로드됐는지 주기적으로 확인
    const interval = setInterval(() => {
      if (window.adsbygoogle) {
        clearInterval(interval);
        pushAd();
      }
    }, CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [insRef]);
};
